import { render, staticRenderFns } from "./RulesFamilyRadarChart.vue?vue&type=template&id=73e38016&scoped=true&"
import script from "./RulesFamilyRadarChart.vue?vue&type=script&lang=js&"
export * from "./RulesFamilyRadarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e38016",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
